import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Box, Grid, Typography, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useSelector } from '../../../redux/store';
import Iconify from '../../../reusable-components/iconify';
import { PENDING_ORDERS } from '../../../reusable-components/datagrid/orderColumns';
import { useScopeCheck } from '../../../reusable-components/scopes';

// ----------------------------------------------------------------------

export default function PendingOrders() {
  const navigate = useNavigate();
  const { orders } = useSelector((state) => state.dashboard.data);
    const hasViewInvoice = useScopeCheck(['Invoice-View'], true);

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" color="primary" sx={{ ml: 0.5 }}>
          Pending Orders
        </Typography>
        <Button
          to="/dashboard/orders?filter=pending"
          component={RouterLink}
          endIcon={<Iconify icon="eva:arrow-forward-fill" width={15} height={5} />}
        >
          View all
        </Button>
      </Grid>
      <Box sx={{ height: hasViewInvoice ? '34vh' : '75vh', width: '100%', mb: 3 }}>
        <DataGridPro
                  getRowHeight={() => 'auto'}
                  rows={orders ?? []}
                  columns={PENDING_ORDERS}
                  getRowId={(row) => row.id}
          onRowClick={(params) => {
            const selection = window.getSelection().toString();
              if (selection.length > 0) return;  
            navigate(`/dashboard/orders/${params.row.id}?filter=pending`);
          }}
                  hideFooter
                  disableColumnMenu
                  disableColumnFilter
                  disableColumnSelector
                  disableColumnPinning
                  disableColumnReorder
                  sx={{
                      '& .no-x-padding': {
                          paddingLeft: 0,
                          paddingRight: 0
                      },
                      '& .no-resizable .MuiDataGrid-iconSeparator': {
                          display: 'none'
                      }
                  }}  
        />
      </Box>
    </>
  );
}
